export enum AffiliateActions {
  Toggled = 'toggled',
  PageChange = 'pageChange'
}